import React, { useState, Fragment, useRef } from "react";

const EmptyBooking = (props, ref) => {

    let opacity = props.opacity ? props.opacity : 1;

    return (
        <div style={{ opacity: opacity }}>
            <div className="d-flex justify-content-between" style={{ marginTop: 10 }}>
                <div className="fakeEvent"></div>
                <div className="fakeEvent"></div>
                <div className="fakeEvent"></div>
                <div className="fakeEvent"></div>
            </div>
            <div className="d-flex justify-content-between" style={{ marginTop: 10 }}>
                <div className="fakeEvent"></div>
                <div className="fakeEvent"></div>
                <div className="fakeEvent"></div>
                <div className="fakeEvent"></div>
            </div>
            <div className="d-flex justify-content-between" style={{ marginTop: 10 }}>
                <div className="fakeEvent"></div>
                <div className="fakeEvent"></div>
                <div className="fakeEvent"></div>
                <div className="fakeEvent"></div>
            </div>
            <div className="d-flex justify-content-between" style={{ marginTop: 10 }}>
                <div className="fakeEvent"></div>
                <div className="fakeEvent"></div>
                <div className="fakeEvent"></div>
                <div className="fakeEvent"></div>
            </div>
        </div>
    );
}

export default React.forwardRef(EmptyBooking);